export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Est-ce un produit physique ?',
    answer:
      'Non. ATLAS VISUEL DE NUTRITION VÉGÉTALE™ est un système 100 % numérique au format PDF, lisible sur ordinateur, tablette ou téléphone, et imprimable pour le terrain.',
  },
  {
    question: 'À qui s’adresse-t-il ?',
    answer:
      'Aux agronomes, aux techniciens agricoles, aux producteurs, aux horticulteurs et aux étudiants en agronomie qui veulent diagnostiquer les problèmes nutritionnels des cultures avec méthode.',
  },
  {
    question: 'Faut-il déjà savoir diagnostiquer une carence ?',
    answer:
      'Non. Le module 1 pose les fondamentaux et chaque module applique la même méthode : OBSERVER › COMPARER › INVESTIGUER › ANALYSER › ÉVALUER › AGIR.',
  },
  {
    question: 'Est-ce un cours théorique ?',
    answer:
      'Non. C’est un système de consultation prêt à l’emploi : fiches atlas, tableaux de référence, arbres de décision, grilles d’interprétation, protocoles, fiches de terrain imprimables et cas pratiques.',
  },
  {
    question: 'Quelles cultures sont couvertes ?',
    answer:
      'Le module 5 traite les céréales, la vigne, le maraîchage, les arbres fruitiers et les cultures sous serre : stades, besoins, symptômes typiques et stratégies.',
  },
  {
    question: 'Les valeurs de référence sont-elles universelles ?',
    answer:
      'Non. Les rangs foliaires, pH et CEC sont donnés à titre indicatif, selon le laboratoire, la culture et le stade. Aucune dose n’est présentée comme une recette universelle : toute intervention se décide après confirmation du diagnostic (analyse de sol ou foliaire) et dans le respect de la réglementation locale.',
  },
  {
    question: 'Les cas pratiques sont-ils réels ?',
    answer:
      'Non. Ce sont des cas pédagogiques fictifs, résolus pas à pas pour entraîner le raisonnement.',
  },
  {
    question: 'Que contiennent les 5 bonus ?',
    answer:
      'Guide des analyses de sol, fiches de terrain imprimables, guide des carences vs maladies, calculs de fertilisation simplifiés et cahier de 40 cas pratiques analysés pas à pas.',
  },
  {
    question: 'Est-ce une certification ou une formation qualifiante ?',
    answer:
      'Non. C’est un support technique et pédagogique. Il ne remplace ni l’avis d’un conseiller agronome, ni les analyses de laboratoire, ni la réglementation en vigueur.',
  },
  {
    question: 'Comment vais-je recevoir le produit ?',
    answer: 'Vous recevez l’accès numérique immédiatement après l’achat, par e-mail.',
  },
]
